import validate from "/app/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.1_@types+node@24.10.0_db0@0.3.4_eslint@8.55.0_ioredis@5.4.1_m_skwgvvvzwgoaahbjh7bi2m4neq/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}